<template>
  <div>

    <form @submit.prevent="getUsers" v-show="step == 0">
      <p class="text-muted">Informe seu CPF para recuperar seu usuário</p>

      <div class="form-group mb-5">
        <FloatingLabel type="tel" input-class="form-control form-control-xl bg-light-2 border-0" label="CPF" v-model="cpf" v-mask="'###.###.###-##'" />
      </div>

      <div class="text-center">
        <a href="#" class="text-wl-secondary font-weight-bold mr-3" @click.prevent="$emit('changeModal', 'login')">Voltar para Login</a>
        <button type="submit" class="btn btn-wl-secondary px-4" :disabled="!disabledForm">Procurar Usuário</button>
      </div>
    </form>



    <div v-show="step == 1">
      <h2 class="text-black">Encontramos {{ foundUsers.length }} usuários atrelados ao seu CPF</h2>
      <!-- <p class="h5 font-weight-normal mb-4">Qual usuário você deseja recuperar?</p>
      <small class="">Enviaremos o código para o telefone cadastrado.</small> -->

      <div class="row mt-2">
        <div class="col-12 mb-3" v-for="(user, index) in foundUsers" :key="index">
          <button
            class="btn btn-white d-flex align-items-center text-left border border-light-dark p-3 w-100"
            >
            <img v-if="user.avatar" :src="user.avatar">
            <account-circle-icon v-else class="img text-wl-secondary" />
            <div class="ml-3">
              <h5 class="m-0">{{ user.name }}</h5>
              <p class="m-0">E-mail: {{ $helpers.censorEmail(user.email) }}</p>
              <p class="m-0" v-if="user.profile.phone">Celular: {{ $helpers.censorPhone(user.profile.phone) }}</p>
              <p class="m-0" v-if="!user.profile.phone">Celular: Não informado</p>
            </div>
          </button>
        </div>

        <hr />
        <br />

        <p class="text-center">
          Ainda não lembra qual é seu e-mail? Entre em contato conosco para recuperar sua conta.
        </p>
      </div>
    </div>



    <form @submit.prevent="validateToken" v-show="step == 2">
      <h2 class="text-black" v-if="selectedUser">Enviamos um código para o número {{ $helpers.censorPhone(selectedUser.profile.phone) }}</h2>
      <p class="h5 font-weight-normal mb-5">Informe-o abaixo para recuperar seu usuário</p>

      <div class="d-flex flex-column justify-content-center form-group mb-5">
        <FloatingLabel type="text" input-class="form-control form-control-xl bg-light-2 border-0" label="Código" v-model="token" v-mask="'######'" />
        <Countdown class="align-self-center" :time="timer" :key="componentKey"/>
      </div>

      <div class="d-flex align-items-center content-buttons-valid-token">
        <a href="#" class="text-wl-secondary font-weight-bold mr-3 disabled" @click="sendSms()" id="resend">Reenviar Código!</a>
        <button type="submit" class="btn btn-wl-secondary px-4" @click="validateToken()" :disabled="token.length < 5">Validar Código</button>
      </div>
    </form>



    <form @submit.prevent="resetEmail" v-show="step == 3">
      <h2 class="text-black">Qual será seu novo e-mail?</h2>
      <p class="h5 font-weight-normal mb-5"></p>

      <div class="form-group mb-5">
        <FloatingLabel type="email" input-class="form-control form-control-xl bg-light-2 border-0" label="Novo e-mail" v-model="newEmail" />
      </div>

      <div class="text-center">
        <button type="submit" class="btn btn-wl-secondary px-4">Recuperar Usuário</button>
      </div>
    </form>



  </div>
</template>

<script>
  import FloatingLabel from '@/components/FloatingLabel';
  import AccountCircleIcon from "vue-material-design-icons/AccountCircle.vue";
  import Countdown from "ninenine-white-label/src/components/Countdown/Countdown.vue";
  import { mapState } from 'vuex'


  export default {
    name: 'ForgotUser',

    data(){
      return {
        step: 0,
        cpf: '',
        foundUsers: [],
        selectedUser: null,
        token: '',
        newEmail: '',
        timer: null,
        componentKey: 0
      }
    },

    components: {
      FloatingLabel,
      AccountCircleIcon,
      Countdown
    },

    computed: {
      disabledForm(){
        return this.$helpers.isCPF(this.cpf)
      },
    },

    mounted(){
      this.timer = 120
      this.initListeners();
    },

    methods: {
      async getUsers(){
        this.$store.commit('DEVISE_LOADING', true);

        this.$store.dispatch("graphql_queries/query", `
          users(cpf: "${ this.cpf }" ){
            id,
            email,
            name,
            avatar,
            profile{
              phone
            }
          }
        `).then( results => {
          if(results.users && results.users.length >= 1){
            this.foundUsers = results.users;
            this.step = 1;
          }else{
            this.$swal({
              title: 'Uoops',
              text: 'Este CPF não está cadastrado',
              type: 'error',
              showCancelButton: true,
              cancelButtonText: 'Não',
              confirmButtonText: 'Sim, quero me cadastrar',
              reverseButtons: true
            }).then((result) => {
              if (result.value) {
                this.$store.commit('DEVISE_TRYING', { document: this.cpf });
                this.$store.commit('DEVISE_FORM', 'register')
              }
            })
          }

          this.$store.commit('DEVISE_LOADING', false);
        });
      },

      async sendSms(){
        let el = document.getElementById('resend')
        this.$store.commit('DEVISE_LOADING', true);
        const sendSms = await this.$store.dispatch('user/generateTokenChangeEmail', { id: this.selectedUser.id }).catch(() => {});
        if(!sendSms || sendSms.error){
          this.$swal('Uoops', 'Ocorreu um problema ao enviar o código para seu celular. Tente novamente mais tarde.', 'error');
          this.$store.commit('DEVISE_LOADING', false);
          return;
        }
        this.step = 2;
        if(el) el.classList.add('disabled');
        this.componentKey += 1;
        this.$store.commit('DEVISE_LOADING', false);
      },

      async validateToken(){
        this.$store.commit('DEVISE_LOADING', true);
        const validTokenEmail = await this.$store.dispatch('user/validTokenEmail', { id: this.selectedUser.id, token: this.token }).catch(() => {});
        if(!validTokenEmail || validTokenEmail.error || validTokenEmail.data.validTokenEmail.valid == false){
          this.$swal('Uoops', 'Ocorreu um problema. Verifique se o token informado é o correto e tente novamente.', 'error');
          this.$store.commit('DEVISE_LOADING', false);
          return;
        }
        this.step = 3;
        this.$store.commit('DEVISE_LOADING', false);
      },

      async resetEmail(){
        this.$store.commit('DEVISE_LOADING', true);
        const changeEmail = await this.$store.dispatch('user/changeEmail', { id: this.selectedUser.id, token: this.token, email: this.newEmail }).catch(() => {});
        if(!changeEmail || changeEmail.error){
          this.$swal('Uoops', 'Ocorreu um problema. Verifique se o e-mail informado está correto e tente novamente.', 'error');
          this.$store.commit('DEVISE_LOADING', false);
          return;
        }
        this.$swal('',"Seu email foi alterado com sucesso.", "success");
        this.$store.commit('DEVISE_LOADING', false);
        this.$store.commit('DEVISE_FORM', 'login');
      },

      initListeners(){
        this.$EventBus.$on('finalCountdown', ()=>{
          let el = document.getElementById('resend')
          if(el) el.classList.remove('disabled');
        })
      },

    },
  }
</script>

<style lang="scss" scoped>
  img{
    width: 50px;
    height: 50px;
    border-radius: 50%;
    object-fit: cover;
  }

  .notice{
    font-size: 12px;
    display: inline-flex;

  }

  /deep/.countdown{
    font-size: 10px !important;
    /deep/p{
      margin-bottom: 0 !important;
    }
    .text-danger{
      color: black !important;
    }
  }

  .img{
    font-size: 50px;
  }

  .content-buttons-valid-token{
    a{
      font-size: 12px;
      &.disabled{
        cursor: not-allowed;
        pointer-events: none;
      }
    }
  }
</style>
